export const FETCH_PARTNER_URL = `${process.env.REACT_APP_API_URL}/partners`;
export const FETCH_PARTNER_URL_LISTING_NULL = `${process.env.REACT_APP_API_URL}/partners/listingnull`;
export const CREATE_PARTNER_URL = `${process.env.REACT_APP_API_URL}/partners`;
export const UPDATE_PARTNER_URL = `${process.env.REACT_APP_API_URL}/partners/update`;
export const DELETE_PARTNER_URL = `${process.env.REACT_APP_API_URL}/partners/delete`;
export const ARCHIVE_PARTNER_URL = `${process.env.REACT_APP_API_URL}/partners/archive`;
export const RESTORE_PARTNER_URL = `${process.env.REACT_APP_API_URL}/partners/restore`;
